routes:
  - name: home
    path: :lang
    restrictions:
      lang: en
    controller: Home
    sitemap:
      priority: 1
      changefreq: yearly
      provider: langs
    children:
      - name: consulting
        path: consulting
        controller: Consulting
        sitemap:
          priority: 0.8
          changefreq: monthly
          lastmodFrom: app/en.yml
      - name: api
        path: 'api{/*id}'
        restrictions:
          id: '[\w/-]+'
        controller: Page
        meta:
          encode: false
          categories: [api]
          ignoreIdPrefix: true
        sitemap:
          priority: 0.7
          changefreq: monthly
          provider: pages
      - name: support-casl
        path: support-casljs
        controller: Page
        sitemap:
          priority: 1
          changefreq: yearly
          provider: route
      - name: page
        path: '*id'
        restrictions:
          id: '[\w/-]+'
        controller: Page
        meta:
          encode: false
          categories: [guide, advanced, package, cookbook]
        sitemap:
          priority: 1
          changefreq: monthly
          provider: pages
